import { getGTMEventData } from '@tracking/components/transformer';

function submitFormatter({
  name, action, lengthOfInput,
  isConfirm, confirmAction, isStatus,
  message, status, category, ...rest
}) {
  let suffix = '';
  let label;
  if (isStatus) {
    suffix = '_status';
    label = status;
  }
  if (isConfirm) {
    suffix = '_confirmation';
    label = confirmAction;
  }
  const eventName = `${name}_${action}${suffix}`;
  return getGTMEventData(
    eventName, eventName, {
      lengthOfInput,
      confirmAction,
      message,
      status,
      ...rest,
    }, label, lengthOfInput, category,
  );
}

export default submitFormatter;
